import { render } from "./InvestorForm.vue?vue&type=template&id=c3ec158e"
import script from "./InvestorForm.vue?vue&type=script&lang=ts"
export * from "./InvestorForm.vue?vue&type=script&lang=ts"
script.render = render

export default script